import React from 'react';
import {
	Modal,
} from 'react-bootstrap';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import { object, func, bool, array } from 'prop-types';
import { AUTH } from '../../../constants';
import style, {mobileStyle} from './style';

const AppMenuModal = ({showMenu,onClose,appMenu,onSelectMenu,profileMenu,t})=>{
	return (
		<Modal
			show={showMenu}
			onHide={onClose}
			bsSize="large"
		>
			<Modal.Header>
				<mobileStyle.ModalHeader>
					{t('header.Menu')}
				</mobileStyle.ModalHeader>
			</Modal.Header>
			<Modal.Body>
				<div>
					{
						appMenu.map(menu=>{
							return (
								<mobileStyle.MenuItemWrapper key={menu.name}>
									<menu.Icon />
									<mobileStyle.MenuItem  onClick={(e)=>{
										onSelectMenu(menu.action,e);
										onClose(e);
									}}>{menu.name}</mobileStyle.MenuItem>	
								</mobileStyle.MenuItemWrapper>
							);
						})
					}
					<style.UserWrapper>
						{profileMenu.map(menu=>{
							return (
								<mobileStyle.MenuItemWrapper key={menu.name}>
									<menu.Icon />
									<mobileStyle.MenuItem onClick={(e)=>{
										onSelectMenu(menu.action,e);
										onClose(e);
									}}>{menu.name}</mobileStyle.MenuItem>
								</mobileStyle.MenuItemWrapper>
					
							);
						})}
					</style.UserWrapper>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<mobileStyle.Footer>
					<mobileStyle.TextButton onClick={onClose}>{t('header.Close')}</mobileStyle.TextButton>
				</mobileStyle.Footer>
			</Modal.Footer>
		</Modal>
	);
};

AppMenuModal.propTypes = {
	showMenu : bool.isRequired,
	onClose : func.isRequired,
	appMenu : array.isRequired,
	onSelectMenu : func.isRequired,
	profileMenu : array.isRequired,
	t : func.isRequired
};

const MobilePresenter = ({auth,onLogin,showMenu,onClickMenu,appMenu,profileMenu,onSelectMenu,onClickHome,t}) =>{
	return (
		<mobileStyle.Wrapper>
			<mobileStyle.Header>
				<style.Leftside>
					<style.Brand onClick={onClickHome}>
						<style.Mushi1Logo />
					MUSHIQUI
					</style.Brand>
				</style.Leftside>
				<style.Rightside>
					{auth.authStatus !== AUTH.LOGGED_IN ? (
						<style.LoginText onClick={onClickMenu(!showMenu)}>
							{t('header.Login')}
						</style.LoginText>
					):
						(<mobileStyle.IconButton onClick={onClickMenu(!showMenu)}>
							<mobileStyle.MenuHamburger />
						</mobileStyle.IconButton>)}
					
				</style.Rightside>
			</mobileStyle.Header>
			{
				auth.authStatus !== AUTH.LOGGED_IN ? (
					<style.Signup 
						show={showMenu}
						onClose={onClickMenu(!showMenu)}
						onLogin={onLogin}
					/>
				) : (
					<AppMenuModal 
						showMenu={showMenu}
						onClose={onClickMenu(!showMenu)}
						appMenu={appMenu}
						onSelectMenu={onSelectMenu}
						profileMenu={profileMenu}
						t={t}
					/>
				)
			}
		</mobileStyle.Wrapper>
	);
};

MobilePresenter.propTypes = {
	onOpenSidebar : func.isRequired,
	isMenuOpened : bool,
	showMenu : bool,
	onClickMenu : func,
	auth: object.isRequired,
	profile: object.isRequired,
	onLogin: func.isRequired,
	appMenu : array,
	profileMenu : array,
	onSelectMenu : func.isRequired,
	onClickHome : func.isRequired,
	t : func.isRequired
};

export default withNamespaces()(MobilePresenter);
